// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-portfolio-page {
  min-height: 100vh;
  padding: 14px 14px 88px;
  background: #ffffff;
  color: #15171a;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans KR", sans-serif;
}

.mobile-loading-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.mobile-loading-text {
  color: #6b7280;
}

.mobile-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.mobile-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.04em;
}

.mobile-brand-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 12px;
  color: #22c55e;
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.16), rgba(16, 185, 129, 0.06));
}

.mobile-top-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-top-actions .ant-btn {
  width: 36px;
  height: 36px;
  font-size: 18px;
  color: #111827;
}

.mobile-alert {
  margin-bottom: 16px;
  border-radius: 18px;
}

.mobile-hero-card {
  padding: 4px 0 18px;
}

.mobile-hero-label {
  margin-bottom: 6px;
  color: #6b7280;
  font-size: 13px;
  font-weight: 700;
}

.mobile-total-assets {
  color: #111827;
  font-size: clamp(30px, 8vw, 42px);
  font-weight: 850;
  line-height: 1.1;
  letter-spacing: -0.06em;
}

.mobile-today-pnl {
  margin-top: 8px;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.mobile-loaded-at {
  margin-top: 6px;
  color: #9ca3af;
  font-size: 12px;
  font-weight: 700;
}

.mobile-positive {
  color: #16a34a !important;
}

.mobile-negative {
  color: #ef4444 !important;
}

.mobile-neutral {
  color: #6b7280 !important;
}

.mobile-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 18px;
}

.mobile-summary-grid > div {
  min-width: 0;
  padding: 12px 10px;
  border: 1px solid #eef0f3;
  border-radius: 18px;
  background: #fafafa;
}

.mobile-summary-grid span,
.mobile-summary-grid small {
  display: block;
  color: #8a929e;
  font-size: 11px;
  font-weight: 700;
}

.mobile-summary-grid strong {
  display: block;
  overflow: hidden;
  margin: 5px 0 2px;
  color: #111827;
  font-size: 12px;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-account-filter-row {
  display: grid;
  grid-auto-columns: minmax(118px, 1fr);
  grid-auto-flow: column;
  gap: 8px;
  overflow-x: auto;
  margin-top: 12px;
  padding-bottom: 4px;
  -webkit-overflow-scrolling: touch;
}

.mobile-account-filter-row button,
.mobile-sort-row button {
  border: 1px solid #eef0f3;
  border-radius: 16px;
  background: #f9fafb;
  color: #6b7280;
  cursor: pointer;
  text-align: left;
}

.mobile-account-filter-row button {
  min-height: 70px;
  padding: 10px;
}

.mobile-account-filter-row button.active,
.mobile-sort-row button.active {
  border-color: rgba(34, 197, 94, 0.42);
  background: rgba(34, 197, 94, 0.1);
  color: #111827;
}

.mobile-account-filter-row span,
.mobile-account-filter-row em,
.mobile-account-filter-row strong,
.mobile-account-filter-row small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-account-filter-row span {
  font-size: 11px;
  font-weight: 800;
}

.mobile-account-filter-row em {
  margin-top: 2px;
  color: #9ca3af;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
}

.mobile-account-filter-row strong {
  margin-top: 5px;
  color: #111827;
  font-size: 13px;
  font-weight: 850;
}

.mobile-account-filter-row small {
  margin-top: 2px;
  font-size: 11px;
  font-weight: 800;
}

.mobile-shortcut-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin: 6px 0 24px;
}

.mobile-shortcut-row a {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 9px 4px;
  color: #6b7280;
  font-size: 12px;
  font-weight: 800;
  text-decoration: none;
}

.mobile-shortcut-row .anticon {
  color: #9ca3af;
  font-size: 24px;
}

.mobile-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.mobile-section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.mobile-section-title h2 {
  margin: 0;
  color: #111827;
  font-size: 24px;
  font-weight: 850;
  letter-spacing: -0.05em;
}

.mobile-section-title span {
  color: #9ca3af;
  font-size: 12px;
  font-weight: 700;
}

.mobile-sort-row {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  margin-bottom: 10px;
  padding-bottom: 2px;
  -webkit-overflow-scrolling: touch;
}

.mobile-sort-row button {
  flex: 0 0 auto;
  padding: 8px 11px;
  font-size: 12px;
  font-weight: 850;
  text-align: center;
}

.mobile-tabs .ant-tabs-nav {
  margin-bottom: 14px;
}

.mobile-tabs .ant-tabs-tab {
  padding: 8px 14px;
  border-radius: 999px;
  color: #6b7280;
  font-size: 14px;
  font-weight: 850;
}

.mobile-tabs .ant-tabs-tab-active {
  background: #f3f4f6;
}

.mobile-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #111827;
}

.mobile-tabs .ant-tabs-ink-bar {
  display: none;
}

.mobile-holding-list,
.mobile-dividend-list,
.mobile-weight-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.mobile-holding-item,
.mobile-dividend-item {
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
}

.mobile-stock-badge,
.mobile-dividend-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  color: #ffffff;
  background: linear-gradient(135deg, #2563eb, #22c55e);
  font-size: 18px;
  font-weight: 850;
  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.16);
}

.mobile-account-badge {
  padding: 0 4px;
  font-size: 11px !important;
  line-height: 1.1;
  text-align: center;
  word-break: keep-all;
}

.mobile-dividend-icon {
  width: 42px;
  height: 42px;
  background: linear-gradient(135deg, #16a34a, #86efac);
  font-size: 20px;
}

.mobile-stock-info,
.mobile-dividend-item > div:nth-child(2) {
  min-width: 0;
}

.mobile-stock-info strong,
.mobile-dividend-item strong {
  display: block;
  overflow: hidden;
  color: #111827;
  font-size: 16px;
  font-weight: 780;
  letter-spacing: -0.04em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-stock-info span,
.mobile-stock-info small,
.mobile-dividend-item span,
.mobile-dividend-item small {
  display: block;
  overflow: hidden;
  color: #6b7280;
  font-size: 12px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-stock-values {
  min-width: 112px;
  text-align: right;
}

.mobile-stock-values strong {
  display: block;
  color: #111827;
  font-size: 15px;
  font-weight: 850;
  letter-spacing: -0.04em;
}

.mobile-stock-values span {
  display: block;
  margin-top: 3px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.mobile-weight-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 80px 42px;
  align-items: center;
  gap: 10px;
  padding: 12px;
  border-radius: 18px;
  background: #fafafa;
}

.mobile-weight-item strong,
.mobile-weight-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-weight-item strong {
  color: #111827;
  font-size: 14px;
}

.mobile-weight-item span {
  color: #6b7280;
  font-size: 13px;
}

.mobile-weight-bar {
  overflow: hidden;
  height: 9px;
  border-radius: 999px;
  background: #e5e7eb;
}

.mobile-weight-bar span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #22c55e, #16a34a);
}

.mobile-weight-item em {
  color: #111827;
  font-style: normal;
  font-weight: 850;
  text-align: right;
}

.mobile-dividend-total-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 14px;
  border-radius: 20px;
  color: #ffffff;
  background: linear-gradient(135deg, #16a34a, #22c55e);
  box-shadow: 0 18px 36px rgba(34, 197, 94, 0.22);
}

.mobile-dividend-total-card span,
.mobile-dividend-total-card strong {
  display: block;
}

.mobile-dividend-total-card span {
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-weight: 700;
}

.mobile-dividend-total-card strong {
  margin-top: 4px;
  font-size: 20px;
  font-weight: 850;
  letter-spacing: -0.05em;
}

.mobile-dividend-total-card .anticon {
  font-size: 28px;
  opacity: 0.9;
}

.mobile-monthly-dividends {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 20px;
}

.mobile-monthly-dividends button {
  padding: 12px;
  border: 1px solid transparent;
  border-radius: 18px;
  background: #f9fafb;
  text-align: left;
  cursor: pointer;
}

.mobile-monthly-dividends button.active {
  border-color: rgba(22, 163, 74, 0.35);
  background: rgba(34, 197, 94, 0.1);
}

.mobile-monthly-dividends span,
.mobile-monthly-dividends strong {
  display: block;
}

.mobile-monthly-dividends span {
  color: #6b7280;
  font-size: 13px;
}

.mobile-monthly-dividends strong {
  margin-top: 4px;
  color: #111827;
  font-size: 14px;
  font-weight: 850;
}

.mobile-dividend-item {
  grid-template-columns: 42px minmax(0, 1fr) auto;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
}

.mobile-dividend-item > strong:last-child {
  min-width: 82px;
  font-size: 14px;
  text-align: right;
}

.mobile-bottom-nav {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 8px 8px max(8px, env(safe-area-inset-bottom));
  border-top: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(14px);
}

.mobile-bottom-nav a,
.mobile-bottom-nav button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 48px;
  border: 0;
  color: #6b7280;
  background: transparent;
  font-size: 11px;
  font-weight: 800;
  text-decoration: none;
}

.mobile-bottom-nav .anticon {
  font-size: 20px;
}

.mobile-bottom-nav .active {
  color: #111827;
}

@media (min-width: 768px) {
  .mobile-portfolio-page {
    max-width: 520px;
    margin: 0 auto;
    border-right: 1px solid #f1f5f9;
    border-left: 1px solid #f1f5f9;
    box-shadow: 0 0 40px rgba(15, 23, 42, 0.06);
  }

  .mobile-bottom-nav {
    right: 50%;
    left: 50%;
    width: 520px;
    margin-left: -260px;
  }
}

@media (max-width: 380px) {
  .mobile-portfolio-page {
    padding-right: 14px;
    padding-left: 14px;
  }

  .mobile-summary-grid {
    grid-template-columns: 1fr;
  }

  .mobile-holding-item {
    grid-template-columns: 48px minmax(0, 1fr);
  }

  .mobile-stock-values {
    grid-column: 2;
    min-width: 0;
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/mobile-portfolio.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,sFAAsF;AACxF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,sFAAsF;AACxF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,qCAAqC;EACrC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,eAAe;AACjB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;EAIE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,sDAAsD;EACtD,6BAA6B;EAC7B,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;IAChB,cAAc;IACd,+BAA+B;IAC/B,8BAA8B;IAC9B,2CAA2C;EAC7C;;EAEA;IACE,UAAU;IACV,SAAS;IACT,YAAY;IACZ,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":[".mobile-portfolio-page {\n  min-height: 100vh;\n  padding: 14px 14px 88px;\n  background: #ffffff;\n  color: #15171a;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Noto Sans KR\", sans-serif;\n}\n\n.mobile-loading-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n}\n\n.mobile-loading-text {\n  color: #6b7280;\n}\n\n.mobile-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 18px;\n}\n\n.mobile-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.04em;\n}\n\n.mobile-brand-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 12px;\n  color: #22c55e;\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.16), rgba(16, 185, 129, 0.06));\n}\n\n.mobile-top-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mobile-top-actions .ant-btn {\n  width: 36px;\n  height: 36px;\n  font-size: 18px;\n  color: #111827;\n}\n\n.mobile-alert {\n  margin-bottom: 16px;\n  border-radius: 18px;\n}\n\n.mobile-hero-card {\n  padding: 4px 0 18px;\n}\n\n.mobile-hero-label {\n  margin-bottom: 6px;\n  color: #6b7280;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.mobile-total-assets {\n  color: #111827;\n  font-size: clamp(30px, 8vw, 42px);\n  font-weight: 850;\n  line-height: 1.1;\n  letter-spacing: -0.06em;\n}\n\n.mobile-today-pnl {\n  margin-top: 8px;\n  font-size: 17px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n}\n\n.mobile-loaded-at {\n  margin-top: 6px;\n  color: #9ca3af;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.mobile-positive {\n  color: #16a34a !important;\n}\n\n.mobile-negative {\n  color: #ef4444 !important;\n}\n\n.mobile-neutral {\n  color: #6b7280 !important;\n}\n\n.mobile-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  margin-top: 18px;\n}\n\n.mobile-summary-grid > div {\n  min-width: 0;\n  padding: 12px 10px;\n  border: 1px solid #eef0f3;\n  border-radius: 18px;\n  background: #fafafa;\n}\n\n.mobile-summary-grid span,\n.mobile-summary-grid small {\n  display: block;\n  color: #8a929e;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.mobile-summary-grid strong {\n  display: block;\n  overflow: hidden;\n  margin: 5px 0 2px;\n  color: #111827;\n  font-size: 12px;\n  font-weight: 850;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mobile-account-filter-row {\n  display: grid;\n  grid-auto-columns: minmax(118px, 1fr);\n  grid-auto-flow: column;\n  gap: 8px;\n  overflow-x: auto;\n  margin-top: 12px;\n  padding-bottom: 4px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.mobile-account-filter-row button,\n.mobile-sort-row button {\n  border: 1px solid #eef0f3;\n  border-radius: 16px;\n  background: #f9fafb;\n  color: #6b7280;\n  cursor: pointer;\n  text-align: left;\n}\n\n.mobile-account-filter-row button {\n  min-height: 70px;\n  padding: 10px;\n}\n\n.mobile-account-filter-row button.active,\n.mobile-sort-row button.active {\n  border-color: rgba(34, 197, 94, 0.42);\n  background: rgba(34, 197, 94, 0.1);\n  color: #111827;\n}\n\n.mobile-account-filter-row span,\n.mobile-account-filter-row em,\n.mobile-account-filter-row strong,\n.mobile-account-filter-row small {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mobile-account-filter-row span {\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.mobile-account-filter-row em {\n  margin-top: 2px;\n  color: #9ca3af;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 700;\n}\n\n.mobile-account-filter-row strong {\n  margin-top: 5px;\n  color: #111827;\n  font-size: 13px;\n  font-weight: 850;\n}\n\n.mobile-account-filter-row small {\n  margin-top: 2px;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.mobile-shortcut-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  margin: 6px 0 24px;\n}\n\n.mobile-shortcut-row a {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 4px;\n  color: #6b7280;\n  font-size: 12px;\n  font-weight: 800;\n  text-decoration: none;\n}\n\n.mobile-shortcut-row .anticon {\n  color: #9ca3af;\n  font-size: 24px;\n}\n\n.mobile-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.mobile-section-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.mobile-section-title h2 {\n  margin: 0;\n  color: #111827;\n  font-size: 24px;\n  font-weight: 850;\n  letter-spacing: -0.05em;\n}\n\n.mobile-section-title span {\n  color: #9ca3af;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.mobile-sort-row {\n  display: flex;\n  gap: 6px;\n  overflow-x: auto;\n  margin-bottom: 10px;\n  padding-bottom: 2px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.mobile-sort-row button {\n  flex: 0 0 auto;\n  padding: 8px 11px;\n  font-size: 12px;\n  font-weight: 850;\n  text-align: center;\n}\n\n.mobile-tabs .ant-tabs-nav {\n  margin-bottom: 14px;\n}\n\n.mobile-tabs .ant-tabs-tab {\n  padding: 8px 14px;\n  border-radius: 999px;\n  color: #6b7280;\n  font-size: 14px;\n  font-weight: 850;\n}\n\n.mobile-tabs .ant-tabs-tab-active {\n  background: #f3f4f6;\n}\n\n.mobile-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #111827;\n}\n\n.mobile-tabs .ant-tabs-ink-bar {\n  display: none;\n}\n\n.mobile-holding-list,\n.mobile-dividend-list,\n.mobile-weight-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.mobile-holding-item,\n.mobile-dividend-item {\n  display: grid;\n  grid-template-columns: 46px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 10px;\n}\n\n.mobile-stock-badge,\n.mobile-dividend-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  color: #ffffff;\n  background: linear-gradient(135deg, #2563eb, #22c55e);\n  font-size: 18px;\n  font-weight: 850;\n  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.16);\n}\n\n.mobile-account-badge {\n  padding: 0 4px;\n  font-size: 11px !important;\n  line-height: 1.1;\n  text-align: center;\n  word-break: keep-all;\n}\n\n.mobile-dividend-icon {\n  width: 42px;\n  height: 42px;\n  background: linear-gradient(135deg, #16a34a, #86efac);\n  font-size: 20px;\n}\n\n.mobile-stock-info,\n.mobile-dividend-item > div:nth-child(2) {\n  min-width: 0;\n}\n\n.mobile-stock-info strong,\n.mobile-dividend-item strong {\n  display: block;\n  overflow: hidden;\n  color: #111827;\n  font-size: 16px;\n  font-weight: 780;\n  letter-spacing: -0.04em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mobile-stock-info span,\n.mobile-stock-info small,\n.mobile-dividend-item span,\n.mobile-dividend-item small {\n  display: block;\n  overflow: hidden;\n  color: #6b7280;\n  font-size: 12px;\n  line-height: 1.35;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mobile-stock-values {\n  min-width: 112px;\n  text-align: right;\n}\n\n.mobile-stock-values strong {\n  display: block;\n  color: #111827;\n  font-size: 15px;\n  font-weight: 850;\n  letter-spacing: -0.04em;\n}\n\n.mobile-stock-values span {\n  display: block;\n  margin-top: 3px;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n}\n\n.mobile-weight-item {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 80px 42px;\n  align-items: center;\n  gap: 10px;\n  padding: 12px;\n  border-radius: 18px;\n  background: #fafafa;\n}\n\n.mobile-weight-item strong,\n.mobile-weight-item span {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mobile-weight-item strong {\n  color: #111827;\n  font-size: 14px;\n}\n\n.mobile-weight-item span {\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.mobile-weight-bar {\n  overflow: hidden;\n  height: 9px;\n  border-radius: 999px;\n  background: #e5e7eb;\n}\n\n.mobile-weight-bar span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #22c55e, #16a34a);\n}\n\n.mobile-weight-item em {\n  color: #111827;\n  font-style: normal;\n  font-weight: 850;\n  text-align: right;\n}\n\n.mobile-dividend-total-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  padding: 14px;\n  border-radius: 20px;\n  color: #ffffff;\n  background: linear-gradient(135deg, #16a34a, #22c55e);\n  box-shadow: 0 18px 36px rgba(34, 197, 94, 0.22);\n}\n\n.mobile-dividend-total-card span,\n.mobile-dividend-total-card strong {\n  display: block;\n}\n\n.mobile-dividend-total-card span {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.mobile-dividend-total-card strong {\n  margin-top: 4px;\n  font-size: 20px;\n  font-weight: 850;\n  letter-spacing: -0.05em;\n}\n\n.mobile-dividend-total-card .anticon {\n  font-size: 28px;\n  opacity: 0.9;\n}\n\n.mobile-monthly-dividends {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.mobile-monthly-dividends button {\n  padding: 12px;\n  border: 1px solid transparent;\n  border-radius: 18px;\n  background: #f9fafb;\n  text-align: left;\n  cursor: pointer;\n}\n\n.mobile-monthly-dividends button.active {\n  border-color: rgba(22, 163, 74, 0.35);\n  background: rgba(34, 197, 94, 0.1);\n}\n\n.mobile-monthly-dividends span,\n.mobile-monthly-dividends strong {\n  display: block;\n}\n\n.mobile-monthly-dividends span {\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.mobile-monthly-dividends strong {\n  margin-top: 4px;\n  color: #111827;\n  font-size: 14px;\n  font-weight: 850;\n}\n\n.mobile-dividend-item {\n  grid-template-columns: 42px minmax(0, 1fr) auto;\n  gap: 10px;\n  padding: 10px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.mobile-dividend-item > strong:last-child {\n  min-width: 82px;\n  font-size: 14px;\n  text-align: right;\n}\n\n.mobile-bottom-nav {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  padding: 8px 8px max(8px, env(safe-area-inset-bottom));\n  border-top: 1px solid #e5e7eb;\n  background: rgba(255, 255, 255, 0.96);\n  backdrop-filter: blur(14px);\n}\n\n.mobile-bottom-nav a,\n.mobile-bottom-nav button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  min-height: 48px;\n  border: 0;\n  color: #6b7280;\n  background: transparent;\n  font-size: 11px;\n  font-weight: 800;\n  text-decoration: none;\n}\n\n.mobile-bottom-nav .anticon {\n  font-size: 20px;\n}\n\n.mobile-bottom-nav .active {\n  color: #111827;\n}\n\n@media (min-width: 768px) {\n  .mobile-portfolio-page {\n    max-width: 520px;\n    margin: 0 auto;\n    border-right: 1px solid #f1f5f9;\n    border-left: 1px solid #f1f5f9;\n    box-shadow: 0 0 40px rgba(15, 23, 42, 0.06);\n  }\n\n  .mobile-bottom-nav {\n    right: 50%;\n    left: 50%;\n    width: 520px;\n    margin-left: -260px;\n  }\n}\n\n@media (max-width: 380px) {\n  .mobile-portfolio-page {\n    padding-right: 14px;\n    padding-left: 14px;\n  }\n\n  .mobile-summary-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .mobile-holding-item {\n    grid-template-columns: 48px minmax(0, 1fr);\n  }\n\n  .mobile-stock-values {\n    grid-column: 2;\n    min-width: 0;\n    text-align: left;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
